module.exports = __webpack_public_path__ + "static/BTP-graphic3-2a05e26e609affc3a0972658796e0240.png";